import { create } from 'zustand'

export type SelectedChatTab = 'chats' | 'apps'
export type SidebarSection = 'chats' | 'chat-history' | 'prompt-library' | 'knowledge-sources'

interface SidebarStore {
  isLeftSidebarOpen: boolean
  isRightSidebarOpen: boolean
  isDraftSidebarExpanded: boolean
  draftSidebarWidth: number
  selectedChatTab: SelectedChatTab
  selectedSidebarSection: SidebarSection
  setIsLeftSidebarOpen: (isOpen: boolean) => void
  setIsRightSidebarOpen: (isOpen: boolean) => void
  setIsDraftSidebarExpanded: (isExpanded: boolean) => void
  setDraftSidebarWidth: (width: number) => void
  setSelectedChatTab: (selectedChatTab: SelectedChatTab) => void
  setSelectedSidebarSection: (section: SidebarSection) => void
}

export const useSidebarStore = create<SidebarStore>((set) => ({
  isLeftSidebarOpen: true,
  isRightSidebarOpen: true,
  isDraftSidebarExpanded: false,
  draftSidebarWidth: 0,
  selectedChatTab: 'chats',
  selectedSidebarSection: 'chats',
  setIsLeftSidebarOpen: (isOpen: boolean) => set({ isLeftSidebarOpen: isOpen }),
  setIsRightSidebarOpen: (isOpen: boolean) => set({ isRightSidebarOpen: isOpen }),
  setIsDraftSidebarExpanded: (isExpanded: boolean) => set({ isDraftSidebarExpanded: isExpanded }),
  setDraftSidebarWidth: (width: number) => set({ draftSidebarWidth: width }),
  setSelectedChatTab: (selectedChatTab: SelectedChatTab) => set({ selectedChatTab }),
  setSelectedSidebarSection: (section: SidebarSection) => set({ selectedSidebarSection: section }),
})) 